import { render, staticRenderFns } from "./getInvolved.vue?vue&type=template&id=64200960"
import script from "./getInvolved.vue?vue&type=script&lang=js"
export * from "./getInvolved.vue?vue&type=script&lang=js"
import style0 from "./getInvolved.vue?vue&type=style&index=0&id=64200960&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports